import {
  FETCH_REPORTS_START,
  FETCH_REPORTS_SUCCESS,
  FETCH_REPORTS_FAILURE,
} from "./actionTypes";

let nextRequestId = 0;

export const fetchReportStart = (params = {})=>{
  return {
    type:FETCH_REPORTS_START,
    requestId: ++nextRequestId,
    payload: params
  };
};

export const fetchReportEnd = (data, requestId)=>{
  return {
    type:FETCH_REPORTS_SUCCESS,
    requestId,
    payload: data
  };
};

export const fetchReportFailure = (error, requestId) => ({
  type: FETCH_REPORTS_FAILURE,
  requestId,
  error: error?.message || "Could not load report",
});
